import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  CreateDocumentInstanceInput,
  CreateDocumentInstanceMutation,
} from '@/gql/graphql';

const CREATE_DOCUMENT_INSTANCE_MUTATION = graphql(`
  mutation CreateDocumentInstance($input: CreateDocumentInstanceInput!) {
    createDocumentInstance(input: $input) {
      id
      name
      documentHtml
    }
  }
`);

const useCreateDocumentInstance = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    CreateDocumentInstanceMutation,
    unknown,
    CreateDocumentInstanceInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_DOCUMENT_INSTANCE_MUTATION, { input });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folderEntries(args.projectId),
        });
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folders(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useCreateDocumentInstance;
